export const GET_GEOGRAPHIC = 'GET_GEOGRAPHIC';
export const SET_GEOGRAPHIC = 'SET_GEOGRAPHIC';
export const GET_COUNTRYCONFIG = 'GET_COUNTRYCONFIG';
export const SET_COUNTRYCONFIG = 'SET_COUNTRYCONFIG';
export const GET_SHOW_RACE_MODULE = 'GET_SHOW_RACE_MODULE';
export const SET_SHOW_RACE_MODULE = 'SET_SHOW_RACE_MODULE';
export const GET_UP_DATA = 'GET_UP_DATA';
